module.exports = __webpack_public_path__ + "static/media/logo_nuestra_casa.f165efa4.svg";